import { useMemo } from 'react';

import {
  globalTranslation,
  mergeTranslations,
  useTranslation,
} from 'modules/i18n';
import iotaTokenIcon from 'modules/icons/assets/iota-token.svg';
import stIotaTokenIcon from 'modules/icons/assets/st-iota-token.svg';
import vusdTokenIcon from 'modules/icons/assets/vusd-token.svg';

import poolsFinanceIcon from '../../icons/pools-finance.png';
import virtueIcon from '../../icons/virtue-finance.png';
import { translation } from './translation';

const mergedTranslation = mergeTranslations(globalTranslation, translation);

export interface IDeFiPool {
  id: string;
  tokens: { name: string; icon: string }[];
  protocol: {
    name: string;
    type: string;
    icon: string;
  };
  network: {
    name: string;
    icon: string;
  };
  link: string;
}

export function useDeFiPools(): IDeFiPool[] {
  const { t, keys } = useTranslation(mergedTranslation);

  return useMemo(() => {
    const data = [];

    data.push({
      id: 'virtue-cdp',
      tokens: [
        {
          name: t(keys.tokens.staked),
          icon: stIotaTokenIcon,
        },
      ],
      protocol: {
        icon: virtueIcon,
        name: 'Virtue',
        type: t(keys.VUSDCDPType),
      },
      network: {
        name: t(keys.iota),
        icon: iotaTokenIcon,
      },
      link: 'https://app.virtue.money/',
    });

    data.push({
      id: 'pools-finance-vusd-cdp',
      tokens: [
        {
          name: t(keys.tokens.native),
          icon: iotaTokenIcon,
        },
        {
          name: t(keys.tokens.staked),
          icon: stIotaTokenIcon,
        },
      ],
      protocol: {
        icon: poolsFinanceIcon,
        name: 'Pools Finance',
        type: t(keys.liquidityPoolType),
      },
      network: {
        name: t(keys.iota),
        icon: iotaTokenIcon,
      },
      link: 'https://app.pools.finance/pool/0xcd2b276437db9612fc7a8d85fe5b3b09a6b5638c0b3ab2003f5f7b284e353d8c/',
    });

    data.push({
      id: 'pools-finance-vusd-cdp-staked',
      tokens: [
        {
          name: t(keys.tokens.staked),
          icon: stIotaTokenIcon,
        },
        {
          name: t(keys.tokens.VUSD),
          icon: vusdTokenIcon,
        },
      ],
      protocol: {
        icon: poolsFinanceIcon,
        name: 'Pools Finance',
        type: t(keys.liquidityPoolType),
      },
      network: {
        name: t(keys.iota),
        icon: iotaTokenIcon,
      },
      link: 'https://app.pools.finance/pool/0x9b5c57e9eb88e85abf9b9b29ac7814ff7289ea2904c2713b5df92c8ebf99fe1b/',
    });

    data.push({
      id: 'pools-finance-farming-vusd',
      tokens: [
        {
          name: t(keys.tokens.staked),
          icon: stIotaTokenIcon,
        },
        {
          name: t(keys.tokens.VUSD),
          icon: vusdTokenIcon,
        },
      ],
      protocol: {
        icon: poolsFinanceIcon,
        name: 'Pools Finance',
        type: t(keys.farmingType),
      },
      network: {
        name: t(keys.iota),
        icon: iotaTokenIcon,
      },
      link: 'https://app.pools.finance/farm/',
    });

    return data;
  }, [
    keys.VUSDCDPType,
    keys.farmingType,
    keys.iota,
    keys.liquidityPoolType,
    keys.tokens.VUSD,
    keys.tokens.native,
    keys.tokens.staked,
    t,
  ]);
}
